import { render } from "./ProductSelectionTrademarksFilters.vue?vue&type=template&id=99619e12&scoped=true&ts=true"
import script from "./ProductSelectionTrademarksFilters.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionTrademarksFilters.vue?vue&type=script&lang=ts"

import "./ProductSelectionTrademarksFilters.vue?vue&type=style&index=0&id=99619e12&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99619e12"]])

export default __exports__